import Bathroom from '../../../assets/room-scene/bathroom.png';
import BathroomThumb from '../../../assets/room-scene/bathroom_tb.jpg';
import Kitchen from '../../../assets/room-scene/kitchen.png';
import KitchenThumb from '../../../assets/room-scene/kitchen_tb.jpg';
import LivingRoomThumb from '../../../assets/room-scene/living-room_tb.jpg';
import LivingRoom from '../../../assets/room-scene/living-room.png';
import Monolithic from '../../../assets/images/Monolithic.png';
import MonolithicHover from '../../../assets/images/MonolithicHover.png';
import QuarterTurn from '../../../assets/images/QuarterTurn.png';
import QuarterTurnHover from '../../../assets/images/QuarterTurnHover.png';
import Ashlar from '../../../assets/images/Ashlar.png';
import AshlarHover from '../../../assets/images/AshlarHover.png';
import Brick from '../../../assets/images/Brick.png';
import BrickHover from '../../../assets/images/BrickHover.png';

export const roomData = [
  // {
  //   id: 'test',
  //   name: 'TestRoom',
  //   src: TestRoom,
  //   surface: [
  //     {
  //       perspective: [
  //         [0.17028985507246377, 0.5771594953089615],
  //         [-0.8504140786749482, 1.0653510190876738],
  //         [0.8009834368530021, 0.5755418958265933],
  //         [1.7220496894409938, 1.0676156583629892],
  //       ],
  //       inchToPixelFactor: 1.128,
  //     },
  //   ],
  // },
  {
    id: 'bathroom',
    name: 'Bathroom',
    thumbnail: BathroomThumb,
    src: Bathroom,
    surface: [
      {
        perspective: null,
        inchToPixelFactor: 4.0,
      },
    ],
  },
  {
    id: 'living-room',
    name: 'Living Room',
    thumbnail: LivingRoomThumb,
    src: LivingRoom,
    surface: [
      {
        perspective: [
          [0.2397598870056497, 0.695268361581921],
          [-0.2589453860640301, 1.0499646892655368],
          [0.8167372881355932, 0.6993290960451978],
          [1.2840160075329567, 1.0911016949152543],
        ],
        inchToPixelFactor: 2.5,
      },
    ],
  },
  {
    id: 'kitchen',
    name: 'Kitchen',
    thumbnail: KitchenThumb,
    src: Kitchen,
    surface: [
      {
        perspective: null,
        inchToPixelFactor: 4.2,
      },
    ],
  },
];

export const groutWidthData = [
  { id: '1/16', jointWidth: 0.1, label1: '1/16"', label2: '(1.6mm)' },
  { id: '1/8', jointWidth: 0.125, label1: '1/8"', label2: '(3.175mm)' },
  { id: '3/16', jointWidth: 0.188, label1: '3/16"', label2: '(4.8mm)' },
  { id: '1/4', jointWidth: 0.25, label1: '1/4"', label2: '(6.35mm)' },
  { id: '3/18', jointWidth: 0.37, label1: '3/18"', label2: '(9.5mm)' },
];

export const tilePattern = [
  {
    installation: 'monolithic',
    name: 'Monolithic',
    thumb: Monolithic,
    thumbHover: MonolithicHover,
    disabled: false,
  },
  {
    installation: 'quarterTurn',
    name: 'Quarter Turn',
    thumb: QuarterTurn,
    thumbHover: QuarterTurnHover,
    disabled: false,
  },
  {
    installation: 'ashlar',
    name: 'Ashlar',
    thumb: Ashlar,
    thumbHover: AshlarHover,
    disabled: false,
  },
  { installation: 'brick', name: 'Brick', thumb: Brick, thumbHover: BrickHover, disabled: false },
];
